import {Cureus} from '../Cureus';

Cureus.AdminMessageTable = {};

//= require_tree ./AdminMessageTable
